import React from 'react';
import Layout from '../../../components/Layout';
import { Breadcrumbs, Typography, Link } from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { Link as RouterLink, Routes, Route, useNavigate, useLocation, Navigate } from 'react-router-dom';
import CategoryIcon from '@mui/icons-material/Category';
import UomPage from './UomPage';

const tabRoutes = [
  { label: 'UOM Master', value: 'uom-master', icon: CategoryIcon },
  // Add more UOM tabs here in the future
];

const segmentLabels = {
  masters: 'Masters',
  uom: 'UOM',
  'uom-master': 'UOM Master',
};

const UomMasterPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const currentTab = tabRoutes.find(tab => location.pathname.split('/').pop() === tab.value)?.value || 'uom-master';
  const handleChange = (event, newValue) => {
    if (newValue !== currentTab) {
      navigate(`/masters/uom/${newValue}`);
    }
  };

  // Breadcrumbs
  const breadcrumbItems = [
    { label: 'Masters', to: '/masters' },
    { label: 'UOM', to: '/masters/uom' },
    { label: segmentLabels[currentTab] || 'UOM Master', to: currentTab },
  ];

  return (
    <Layout>
      {/* Breadcrumbs */}
      <Breadcrumbs
        separator={<NavigateNextIcon fontSize="small" sx={{ color: '#00C853' }} />}
        aria-label="breadcrumb"
        sx={{ mb: 2, mt: 1 }}
      >
        {breadcrumbItems.map((item, idx) =>
          idx === breadcrumbItems.length - 1 ? (
            <Typography
              key={item.to}
              sx={{ color: '#111', fontWeight: 700, fontSize: 18, letterSpacing: 1, fontFamily: 'inherit' }}
            >
              {item.label}
            </Typography>
          ) : (
            <Link
              key={item.to}
              component={RouterLink}
              to={item.to}
              underline="hover"
              sx={{ color: '#111', fontWeight: 500, fontSize: 16, letterSpacing: 1, fontFamily: 'inherit', transition: 'color 0.3s ease', '&:hover': { color: '#111', fontWeight: 600 } }}
            >
              {item.label}
            </Link>
          )
        )}
      </Breadcrumbs>
      {/* Tabs */}
      <div style={{ display: 'flex', alignItems: 'center', position: 'relative', marginBottom: 16 }}>
        <div
          style={{
            display: 'flex',
            overflow: 'hidden',
            flex: 1,
            borderBottom: '1.5px solid #e5e7eb',
            minHeight: 56,
            paddingBottom: 2,
          }}
        >
          {tabRoutes.map((tab) => {
            const Icon = tab.icon;
            return (
              <button
                key={tab.value}
                onClick={() => handleChange(null, tab.value)}
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  minWidth: 120,
                  minHeight: 56,
                  padding: '12px 24px',
                  marginRight: 8,
                  border: 'none',
                  borderRadius: '8px 8px 0 0',
                  background: currentTab === tab.value ? '#E8F5E9' : 'transparent',
                  color: '#111',
                  fontWeight: currentTab === tab.value ? 700 : 500,
                  fontSize: 16,
                  letterSpacing: 0.5,
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  boxShadow: 'none',
                  outline: 'none',
                  borderBottom: currentTab === tab.value ? '4px solid #00C853' : '4px solid transparent',
                }}
              >
                <span style={{ fontSize: 22, color: currentTab === tab.value ? '#00C853' : '#757575', marginRight: 30 }}><Icon /></span>
                {tab.label}
              </button>
            );
          })}
        </div>
      </div>
      {/* Tab Content */}
      <Routes>
        <Route index element={<Navigate to="uom-master" />} />
        <Route path="uom-master" element={<UomPage />} />
        {/* Add more tab routes here as needed */}
        <Route path="*" element={<div>Not Found: {location.pathname}</div>} />
      </Routes>
    </Layout>
  );
};

export default UomMasterPage; 